module.exports = __webpack_public_path__ + "static/media/logo.1bf17cca.svg";